import type { FormField } from '../types';

/**
 * Default newly authored contact fields once. Existing fields, including an
 * explicitly disabled first source, keep ownership of their guest property.
 * Loading, editing labels and duplicating questions must not call this helper.
 */
export function applyDefaultGuestBindings<T extends FormField>(added: readonly T[], existing: readonly FormField[] = []): T[] {
  const existingTypes = new Set(existing.map(field => field.type));
  const chosen = new Map<string, T>();
  for (const type of ['name', 'email'] as const) {
    if (existingTypes.has(type)) continue;
    const source = added.find(field => field.type === type && field.profileBinding?.property === type)
      ?? added.find(field => field.type === type);
    if (source) chosen.set(type, source);
  }
  return added.map(field => {
    if (field.type !== 'name' && field.type !== 'email') return field;
    if (chosen.get(field.type) === field) {
      return { ...field, profileBinding: { version: 1, subject: 'guest', property: field.type } };
    }
    if (!field.profileBinding) return field;
    const unbound = { ...field };
    if (unbound.type === 'name' || unbound.type === 'email') delete unbound.profileBinding;
    return unbound;
  });
}
